"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
exports.Executor = react_1.memo(function Executor(props) {
    var _a;
    const args = (_a = props.args) !== null && _a !== void 0 ? _a : [];
    const result = props.useStore(...args);
    props.container.state = result;
    props.container.initialized = true;
    react_1.useEffect(() => {
        props.onChange(result);
        props.container.notify();
    });
    return null;
}, (prevProps, nextProps) => {
    if (!nextProps.memo) {
        return false;
    }
    else {
        return argsAreEqual(prevProps.args, nextProps.args);
    }
});
function argsAreEqual(args1, args2) {
    if (args1 === args2)
        return true;
    if (args1.length !== args2.length)
        return false;
    return args1.every((element, index) => element === args2[index]);
}
